import React, { useState, useEffect } from "react";
import { Quote } from "../../Components/Icons";
import * as S from "./style";

const content = [
  {
    id: 1,
    qouteicon: <Quote />,
    descraption: "He is very good perfect work",
    name: "Yousef Sheikho",
    subtitle: "Founder of a shipping website",
  },
  {
    id: 2,
    qouteicon: <Quote />,
    descraption:
      "Fantastic guy. He delivers exactly what you want and on time. I surely recommend his services. Thank you",
    name: "Fawad Bin Tariq",
    subtitle: "Freelancer As Front-End Developer",
  },
  {
    id: 3,
    qouteicon: <Quote />,
    descraption: "It was a pleasure working with Maher",
    name: "Saad Alrawaf",
    subtitle: "Founder & Owner Saad Company",
  },
];

export default function Slider() {
  const [show, setShow] = useState(1);

  const handleClick = (e) => {
    const { id } = e.target;
    const newid = Number(id);
    setShow(newid);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (show > 0) {
        setShow((show) => {
          let newShow = show + 1;
          return newShow > 3 ? 1 : newShow;
        });
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [show]);

  return (
    <S.Slider>
      <div className="row">
        {content.map((item) => (
          <S.Carousel className={`show${show}`} key={item.id}>
            {item.qouteicon}
            <p className="para">{item.descraption}</p>
            <h2 className="name-person">{item.name}</h2>
            <p className="subtitle">{item.subtitle}</p>
          </S.Carousel>
        ))}
      </div>

      <S.Dotes>
        <S.Doteitem
          id={1}
          onClick={handleClick}
          className={`${show === 1 ? "active" : ""}`}
        />
        <S.Doteitem
          id={2}
          onClick={handleClick}
          className={`${show === 2 ? "active" : ""}`}
        />
        <S.Doteitem
          id={3}
          onClick={handleClick}
          className={`${show === 3 ? "active" : ""}`}
        />
      </S.Dotes>
    </S.Slider>
  );
}
